import { useQuery } from "@tanstack/react-query";
import { feedRepository } from "@/config/dataSource";

export function useLeagueFeed(leagueId: string | undefined) {
  return useQuery({
    queryKey: ["feed", leagueId ?? "unknown"],
    queryFn: () => feedRepository.getFeed(leagueId as string),
    enabled: Boolean(leagueId),
    // O cron agora roda com frequência alta (configurado pelo usuário na
    // Hostinger) — atualiza sozinho enquanto a tela estiver aberta, pra
    // gol/MVP/duelo aparecerem sem precisar sair e voltar da tela.
    refetchInterval: 60_000,
  });
}
